export const contentTableConfig = {
  title: '审批列表',
  propList: [
    {prop: 'eventName', label: '事件名称', minWidth: '120', slotName: 'consumer', align: 'left'},
    {prop: 'corpName', label: '主体名称', minWidth: '60'},
    {prop: 'handoverUserid', label: '交接账号', minWidth: '60'},
    {prop: 'takeoverUserid', label: '承接账号', minWidth: '60'},
    {prop: 'customerNum', label: '转移数量', minWidth: '40'},
    {prop: 'transferSuccessMsg', label: '发送语', minWidth: '60', align: 'left'},
    {prop: 'transferType', label: '转移类型', minWidth: '80', slotName: 'type'},
    {prop: 'createdName', label: '发起人', minWidth: '60'},
    {prop: 'createdTime', label: '发起时间', minWidth: '60', sortable: 'custom'},
    {label: '查看详情', minWidth: '60', slotName: 'handler'},
    {prop: 'approvalStatus', label: '审批状态', minWidth: '60', slotName: 'status'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
